/* import __COLOCATED_TEMPLATE__ from './lsg-highlight-circle.hbs'; */
import Component from '@ember/component';

/**
 * A yellow highlight circle for providing emphasis
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'span',
  classNames: ['LSG-c-highlight-circle']
});
